import { ParseUserInitials } from "@myinnsworth/helpers/userHelpers";
import { useAuthentication } from "@myinnsworth/hooks/authenticationHook";
import { authenticationHttpService } from "@myinnsworth/httpServices";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

export default function UserProfile() {
    const [optionsOpen, setOptionsOpen] = useState<boolean>(false);
    const [userInitials, setUserInitials] = useState<string>('');

    const auth = useAuthentication();

    useEffect(() => {
        setUserInitials(ParseUserInitials({forename: auth.user?.forename, surname: auth.user?.surname}));
    }, [auth]);

    const signOut = async () => {
        try {
            await authenticationHttpService.signOut();
        } catch {}
    };

    return (
        <div className="profile-container">
            <div onClick={() => setOptionsOpen(!optionsOpen)} className="user-profile">
                <span>{userInitials}</span>
                {/* <img src="" alt=""> */}
                <p>{auth.user?.displayName}</p>
            </div>

            <div className={`profile-menu ${optionsOpen ? 'opened' : ''}`}>
                <ul>
                    <li><Link to={"/settings/profile"} onClick={() => setOptionsOpen(false)}>Profile settings</Link></li>
                    <li><Link to={"/settings/account"} onClick={() => setOptionsOpen(false)}>Account settings</Link></li> 
                    <li><Link to={"/auth/sign-in"} onClick={() => signOut()}>Log out</Link></li> 
                </ul>
            </div>
        </div>
    )
}

